module.exports = __webpack_public_path__ + "static/media/nicsell_output.0c625949.csv";